<template>
    <div class="container" :class="{ 'dark-mode': isDarkMode }">
      <div class="main-content" :class="{ 'with-file': uploadedFile }">
        <!-- File Upload Section - Only show when file is uploaded -->
        <div v-if="uploadedFile" class="file-upload-section">
          <FileUpload @file-uploaded="handleFileUpload" :uploadedFile="uploadedFile" />
        </div>
        
        <!-- Chat Section - Always show, but adjust width based on file presence -->
        <div class="chat-section" :class="{ 'full-width': !uploadedFile }">
          <ChatInterface :uploadedFile="uploadedFile" @file-uploaded="handleFileUpload" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import FileUpload from '@/components/Fluidsdatapal/FileUpload.vue';
  import ChatInterface from '@/components/Fluidsdatapal/ChatInterface.vue';
  import { mapActions, mapGetters } from "vuex";
  
  export default {
    components: {
      FileUpload,
      ChatInterface,
    },
    computed: {
      ...mapGetters("darkMode", ["isDarkMode"]),
    },
    data() {
      return {
        uploadedFile: null
      };
    },
    methods: {
      ...mapActions("tenantId", ["getUserData"]),
      handleFileUpload(file) {
        this.uploadedFile = file; // Update the uploaded file (can be null when removed)
      },
    },
    mounted() {
      this.getUserData(); // Call the getUserData method from Vuex on component mount
    },
  };
  </script>
  
  <style scoped>
  .container {
    display: flex;
  }
  
  
  .main-content {
    flex: 1;
    display: flex;
    flex-direction: row;
    padding: 16px;
    background: #f4f6f8;
    height: 100vh;
  }

  .main-content.with-file {
    gap: 16px;
  }
  
  .main-content.with-file .file-upload-section {
    flex: 1;
    min-width: 0;
    max-width: 50%;
  }
  
  .main-content.with-file .chat-section {
    flex: 1;
    min-width: 0;
    max-width: 50%;
  }
  
  .file-upload-section {
    flex: 1;
    border: 2px dashed #ccc;
    background: #fff;
    border-radius: 10px;
    min-height: 300px;
    width: 100%;
    padding: 16px;
  }
  
  .chat-section {
    flex: 1;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    min-width: 0;
    overflow: hidden;
  }

  .chat-section.full-width {
    flex: 1;
    width: 100%;
  }
  </style>